import {
  databaseRef,
  firestoreRef,
  usersRef,
  authRef,
  productsRef,
  usersUnitsRef,
  sportsRef,
  participantsRef,
  sportEventsRef,
  premiumBetsRef,
  freeBetPageRef,
  betsRef,
  betsAvrageRef,
  betsWeeklyRef,
  betsMonthlyRef,
  betVideosRef,
  ordersRef,
  fcmSubscriptionsRef,

  provider,
  providerFacebook,
  firebaseMessaging,

  serverTimestamp,
  subscribersRef,

  cloudFunction
} from "../config/firebase";
import {

  FETCH_USERS_INFO,
  CHANGE_AUTH_USER_INFO,
  FETCH_USER_INFO,
  SHOW_LOGIN_DIALOG,

  FETCH_USERS_UNITS,
  FETCH_USER_UNITS,

  SHOW_ORDER_DIALOG,
  ORDER_COMMITED,

  FETCH_USER,
  LOGIN_SUCCESS,
  LOGIN_USER_NOT_FOUND,
  LOGIN_INCORRECT_CREDENTIALS,
  LOGIN_PASSWORD_RESET,

  REGISTER_SUCCESS,

  FETCH_ALL_SUBSCRIBERS,

  FETCH_ALL_PRODUCTS,

  FETCH_ALL_SPORTS,
  FETCH_SPORT_PARTICIPANTS,
  FETCH_SPORT_EVENTS,

  FETCH_PREMIUM_BETS,
  FETCH_BETS_HISTORY,

  FETCH_PACKAGE_STATISTIC,
  FETCH_STATISTIC,
  FETCH_STATISTIC_MONTH,

  FETCH_FREE_BET_PAGE,

  FETCH_BET_VIDEOS,

  FETCH_ALL_ORDERS,
  FETCH_USER_ORDERS,
  FETCH_USER_HISTORY_ORDERS,
  FETCH_ALL_HISTORY_ORDERS,

  ACTIVE_NAV_LINK,

  SHOW_USER_AGREEMENT,

  FETCH_FCM_USER_SUBSCRIPTIONS,
  UPDATE_FCM_USER_SUBSCRIPTIONS,
  SET_DEVICE_FCM_TOKEN,
  DEVICE_FCM_TOKEN_SUPORTED,

  DISPLAY_INFO_DATA,
  TRANSACTION_START,
  TRANSACTION_END,
  MONETA_TRANSACTION_STATUS,

} from "./types";

import moment from 'moment'
import ReactPixel from 'react-facebook-pixel';
// TEST
export const test = () => dispatch =>{

  ordersRef.child("history/users").equalTo("-LKum1BavKVLDwWPQ0_6")
    .once("value",(snapshot)=>{
      console.log(snapshot.val())
    })
    .catch((err)=>{
      console.log(err)
    })
}


/// NAVIGATION ACTION

export const setNavigationActiveLink = (activatedLink) => dispatch =>{

  dispatch({
    type: ACTIVE_NAV_LINK,
    state: activatedLink
  });
}

/// WEB PAGE ACTIONS

export const showUserAgreementDialog = (state) => dispatch =>{

  dispatch({
    type: SHOW_USER_AGREEMENT,
    isActive: state
  });
}

/// USER DEVICES
export const updateUserDevices = (uid, devices ) => dispatch => {
  console.log("updateUserDevices")
  usersRef.update({[uid+"/metadata/devices"]: devices})

}

export const changeUserDevices = (uid, currentDevice, currentDeviceId, changedDeviceId) => (dispatch, getState) => {

  let devices = {...getState().auth.devices}
  let devicesData = {...devices.data}
  if(moment.unix(devices.lastDeviceChanged).month() === moment().month()){
    devices.devicesChangedThisMonth += 1
  }else{
    devices.devicesChangedThisMonth =  1
  }
  devices.lastDeviceChanged = moment().unix()
  delete devicesData[changedDeviceId]
  devicesData = {...devicesData, ...currentDevice}

  devices.data = devicesData
  console.log(devices)
  usersRef.update({[uid+"/metadata/devices"]: devices})
          .then(()=>window.location.replace("/mojestave"))
}

//// USER ACTIONS
export const fetchUsersStream = () => async dispatch =>{
  console.log("fetchUsersStream")
  usersRef.on("value", snapshot => {

    dispatch({
      type: FETCH_USERS_INFO,
      payload: snapshot.val()
    });
  });
}

export const fetchUsersOnce = () => async dispatch =>{
  console.log("fetchUsersOnce")
  usersRef.orderByKey().limitToFirst(10).once("value", snapshot => {

    dispatch({
      type: FETCH_USERS_INFO,
      payload: snapshot.val()
    });
  });
}

export const fetchUsersOnceByEmail = (searchedString) => async(dispatch, getState) =>{

  if(searchedString.length >= 3 ){
    console.log("fetchUsersOnceByEmail")
    usersRef.orderByChild("email").startAt(searchedString).limitToFirst(10).once("value", snapshot => {

      dispatch({
        type: FETCH_USERS_INFO,
        payload: snapshot.val()
      });
    });
  }

}

export const fetchUserInfo = (uid) => async (dispatch, getState) =>{
  console.log("fetchUserInfo")
  // if state usersInfoData already exsist, check if contains searched uid, retrun it from list(ther is no need for api call)
  if(getState().usersInfoData[uid]){

    dispatch({
      type: FETCH_USER_INFO,
      payload:  getState().usersInfoData[uid]
    });
  }else{
    // if userInfoData is null or doesnt contain uid, fetch it from API
    usersRef.child(uid).once("value", snapshot => {

      dispatch({
        type: FETCH_USER_INFO,
        payload: snapshot.val()
      });
    })
    .catch((err)=>{
      console.log(err)
    })
  }
}

export const fetchUserInfoStream = (uid) => async (dispatch, getState) =>{
  console.log("fetchUserInfoStream")
  // if state usersInfoData already exsist, check if contains searched uid, retrun it from list(ther is no need for api call)

    // if userInfoData is null or doesnt contain uid, fetch it from API
    usersRef.child(uid).on("value", snapshot => {
        dispatch({
          type: FETCH_USER_INFO,
          payload: snapshot.val()
        });
      },(err)=>{
        console.log(err)
    })

}

export const editUserInfo = (uid, userInfo) => async (dispatch, getState) =>{
  //rewriting entire userInfo object, there is no need for updating changed field
  dispatch({
    type: TRANSACTION_START,
    status: "processing"
  })
  let updateObject = {}
  if(!userInfo.email){
    return dispatch({
      type: TRANSACTION_END,
      message: {title:"Uporabnik nima potrjenega e-poštnega naslova!", body:"", type:"error"},
    })
  }
  if(userInfo.metadata.access){
    Object.entries(userInfo.metadata.access.packages).forEach(([packageKey, packageAccess])=>{
      // IF PACKAGE  ACCESS HAS UNIT LIMITS
      if(packageAccess){
        if( packageAccess.userUnits){
          let userUnits = {...packageAccess.userUnits}
          updateObject["usersUnits/packages/"+packageKey+"/users/"+uid+"/data"] = userUnits
          delete packageAccess.userUnits
        }
        let activeSub =  packageAccess
        activeSub.email = userInfo.email
        updateObject["activeSubs/packages/"+packageKey+"/"+uid] = activeSub
      }else{
        updateObject["activeSubs/packages/"+packageKey+"/"+uid] = null
      }


    })
  }


  updateObject["users/"+uid] = userInfo

  databaseRef
    .update(updateObject)
    .then(()=>{
      dispatch({
        type: TRANSACTION_END,
        message: {title:"Spremembe uspešno posodobljene!", body:"", type:"info"},
      })
    })
    .catch((err)=>{
      dispatch({
        type: TRANSACTION_END,
        message: {title:"Prišlo je do napake!", body:"Osveži spletno stran in piskusi ponovno!", type:"error"},
      })
  })
}

export const updateUserInfo = (uid, userInfo ) => async (dispatch) =>{
  //rewriting entire userInfo object, there is no need for updating changed field
  console.log(uid, userInfo)
  usersRef
   .child(uid)
   .update(userInfo)
   .then(()=>{
     dispatch({
       type: CHANGE_AUTH_USER_INFO,
       payload: userInfo,
     })
     dispatch({
       type: DISPLAY_INFO_DATA,
       payload: {title:"Profil uspešno posodobljen!"},
     })
   })
   .catch((err)=>{
     dispatch({
       type: DISPLAY_INFO_DATA,
       payload: {title:"Prišlo je do napake!", message: "Osveži stran in poiskusi ponovno!"},
     })
   })

}

export const fetchUser = () =>  dispatch => {
  console.log("fetchUser")
  authRef.onAuthStateChanged( user => {

    if (user) {
      usersRef.child(user.uid).once("value", snapshot => {

        if(snapshot.val()){
          let userInfo = snapshot.val()
          user.admin = userInfo.admin
          user.name = userInfo.firstName
          user.mod = userInfo.mod
          user.access = userInfo.metadata && userInfo.metadata.access
          user.devices = userInfo.metadata && userInfo.metadata.devices
          user.info = {
            lastName: userInfo.lastName,
            firstName: userInfo.firstName,
            address: userInfo.address,
            city: userInfo.city,
            postalNumber: userInfo.postalNumber,
          }
        }
        dispatch({
          type: FETCH_USER,
          payload: user
        });

      })
      .catch(err=>{
        console.log(err)
      })

    }else {
      dispatch({
        type: FETCH_USER,
        payload: null
      });
    }
  });
};


/// SUBSCRIBTIONS

export const fetchAllActiveSubscribers = (packagesKeys) => async dispatch =>{
  let queries = []
  packagesKeys.forEach(packageKey =>  queries.push(subscribersRef.child('packages/'+packageKey).orderByChild("expiresAt").startAt(moment().unix()).once('value', (snapshot)=> snapshot)))


  let subscriptions = {}
  Promise
    .all(queries)
    .then(data=>{

      data.forEach((snapshot, i)=>{
          //console.log(snapshot.val())
        subscriptions = {
          ...subscriptions,
          [packagesKeys[i]]:{
            ...snapshot.val()
          }
        }
      })
      dispatch({
        type: FETCH_ALL_SUBSCRIBERS,
        payload: subscriptions
      })
    })
    .catch((errors)=>{
      console.log(errors)
    })

}

//// USERS UNITS

export const fetchUserUnitsOnce = (userId, packageId)=> dispatch =>{
  usersUnitsRef.child('packages/'+packageId+"/users/"+userId+"/data").once('value', snapshot=>{
    dispatch({
      type: FETCH_USER_UNITS,
      userId,
      packageId,
      payload: snapshot.val()
    })
  })
  .catch((err)=>console.log(err))
}


//// ORDERS actions
export const orderDialogState = (active) => dispatch => {
  dispatch({
    type: SHOW_ORDER_DIALOG,
    isActive: active
  });
};

//// PRODUCTS ACTIONS

export const fetchAllProductsOnce = () => async  dispatch => {
    console.log("fetchAllProductsOnce")
    productsRef.once("value", snapshot => {
      let products = {...snapshot.val()}

      Object.keys(products).forEach(productKey=>{

        if(products[productKey].settings.frozen)delete products[productKey]

      })

      dispatch({
        type: FETCH_ALL_PRODUCTS,
        payload: products
      });
    })
    .catch(err=>console.log(err))
};


export const fetchAllProductsStream= () => async  dispatch => {
    console.log("fetchAllProductsStream")
    productsRef.on("value", snapshot => {

      dispatch({
        type: FETCH_ALL_PRODUCTS,
        payload: snapshot.val()
      });
    })
};

export const createProduct = (product) => async  dispatch => {
    productsRef
      .push()
      .set(product)
      .catch((err)=>{
        // TODO: catch error
      })
};

export const updateProduct = (product, id) => async  dispatch => {
    productsRef
      .child(id)
      .set(product)
      .catch((err)=>{
        // TODO: catch error
      })
};

export const deleteProduct = (id) => async  dispatch => {
    productsRef
      .child(id)
      .remove()
      .catch((err)=>{
        // TODO: catch error
      })
};

/*

export const fetchAllPackagesOnce = () => async  dispatch => {
    packagesRef.get()
      .then(snapshot => {
        let packages = {}
        snapshot.forEach((doc)=>{packages[doc.id] = doc.data()})
        if (!packages) {
          // TODO: dispatch statment for no results
          console.log('No such document!');
        } else {
          dispatch({
            type: FETCH_ALL_PRODUCTS,
            payload: packages
          });
        }

      })
      .catch(err => {
        // TODO: dispatch statment for error
        console.log('Error getting document', err);
      });

}


export const fetchAllPackagesStream = () => async  dispatch => {
  packagesRef.onSnapshot((snapshot) => {
        let packages = {}

        snapshot.forEach((doc)=>{packages[doc.id] = doc.data()})

        dispatch({
          type: FETCH_ALL_PRODUCTS,
          payload: packages
        });

      }, (error) => {
        console.log(error)
        // TODO: dispatch error
      });

};

export const createPackage = (packageObj) => async  dispatch => {
    packagesRef.add(packageObj)
               .then(ref => {
                //console.log('Added document with ID: ', ref.id);
               });
}

export const updatePackage = (packageObj, id) => async  dispatch => {
  packagesRef.doc(id).set(packageObj)
             .then(ref => {
              //console.log('Added document with ID: ', ref.id);
             });
};

export const deletePackage = (id) => async  dispatch => {
    packagesRef.doc(id).delete()
};
*/
///// SPORTS DATA ACTIONS
export const fetchAllSportsOnce = () => async  dispatch => {
    console.log("fetchAllSportsOnce")
    sportsRef.once("value", snapshot => {

      dispatch({
        type: FETCH_ALL_SPORTS,
        payload: snapshot.val()
      });
    })
    .catch(err=>console.log(err))
};

export const fetchAllSportsStream = () => async  dispatch => {
    console.log("fetchAllSportsStream")
    sportsRef.on("value", snapshot => {
      dispatch({
        type: FETCH_ALL_SPORTS,
        payload: snapshot.val()
      });
    })
};

export const addSport = (sport) => async  dispatch => {

    sportsRef
      .push()
      .set(sport)
      .catch((err)=>{
        // TODO: catch error
      })
};

export const deleteSport = (sportId) => async  dispatch => {

    sportsRef
      .child(sportId)
      .remove(()=>{
        //if remove is successful, we also need to delete sport particiapnts and sport events that are linked to sportId
        participantsRef
          .child(sportId)
          .remove()
          .catch((err)=>{
            // TODO: catch error
          })

        sportEventsRef
          .child(sportId)
          .remove()
          .catch((err)=>{
            // TODO: catch error
          })
      })
      .catch((err)=>{
        // TODO: catch error
      })
};


/// PARTICIPANTS ACTIONS

export const fetchSportParticipantsStream = (sportId) => async  dispatch => {
    console.log("fetchSportParticipantsStream")
    participantsRef.child(sportId).on("value", snapshot => {

      dispatch({
        type: FETCH_SPORT_PARTICIPANTS,
        sportId: sportId,
        payload: snapshot.val()
      });
    })
};

export const fetchSportParticipantsOnce = (sportId) => async  dispatch => {
    console.log("fetchSportParticipantsOnce")
    participantsRef.child(sportId).once("value", snapshot => {

      dispatch({
        type: FETCH_SPORT_PARTICIPANTS,
        sportId: sportId,
        payload: snapshot.val()
      });
    })
    .catch(err=>console.log(err))
};

export const addSportParticipant = (sportId, participant) => async  dispatch => {

    participantsRef
      .child(sportId)
      .push()
      .set(participant)
      .catch((err)=>{
        // TODO: catch error
      })
};

export const editSportParticipant = (sportId, participantId, participant) => async  dispatch => {

    participantsRef
      .child(sportId+"/"+participantId)
      .set(participant)
      .catch((err)=>{
        // TODO: catch error
      })
};

export const deleteSportParticipants = (sportId, participantsIds) => async  dispatch => {
    console.log(participantsIds)
    dispatch({
      type: TRANSACTION_START,
      error: null,
      status: "processing"
    });
    let promises = participantsIds.map(participantId=>   participantsRef.child(sportId+"/"+participantId).remove())

    Promise
      .all(promises)
      .then(()=>{
        dispatch({
          type: TRANSACTION_END,
          message: {title: "Brisanje je bilo uspešno izvedeno!", body:null, type:"info"},
          status: "processing"
        });
      })
      .catch(()=>{
        dispatch({
          type: TRANSACTION_END,
          message: {title: "Prišlo je do napake!", body:"Osveži stran in poiskusi ponovno!", type:"error"},
          status: "error"
        });
      })

};

//// SPORT EVENTS ACTION


export const fetchSportEventsStream = (sportId) => async  dispatch => {
    console.log("fetchSportEventsStream")
    sportEventsRef.child(sportId).on("value", snapshot => {

      dispatch({
        type: FETCH_SPORT_EVENTS,
        sportId: sportId,
        payload: snapshot.val()
      });
    })
};

export const fetchSportEventsOnce = (sportId) => async  dispatch => {
    console.log("fetchSportEventsOnce")
    sportEventsRef.child(sportId).once("value", snapshot => {

      dispatch({
        type: FETCH_SPORT_EVENTS,
        sportId: sportId,
        payload: snapshot.val()
      });
    })
    .catch(err=>console.log(err))
};

export const addSportEvent = (sportId, sportEvent) => async  dispatch => {

    sportEventsRef
      .child(sportId)
      .push()
      .set(sportEvent)
      .catch((err)=>{
        // TODO: catch error
      })
};

export const editSportEvent = (sportId, sportEventId, sportEvent) => async  dispatch => {

    sportEventsRef
      .child(sportId+"/"+sportEventId)
      .set(sportEvent)
      .catch((err)=>{
        // TODO: catch error
      })
};

export const deleteSportEvents = (sportId, sportEventsIds) => async  dispatch => {
    dispatch({
      type: TRANSACTION_START,
      error: null,
      status: "processing"
    });
    console.log(sportEventsIds)
    let promises = sportEventsIds.map(sportEventId=>   sportEventsRef.child(sportId+"/"+sportEventId).remove())
    Promise
      .all(promises)
      .then(()=>{
        dispatch({
          type: TRANSACTION_END,
          message: {title: "Brisanje je bilo uspešno izvedeno!", body:null, type:"info"},
          status: "processing"
        });
      })
      .catch(()=>{
        dispatch({
          type: TRANSACTION_END,
          message: {title: "Prišlo je do napake!", body:"Osveži stran in poiskusi ponovno!", type:"error"},
          status: "error"
        });
      })

};


// BETS ACTIONS
export const createNewPremiumBet = (bet) => async  dispatch => {
    premiumBetsRef
      .child('active/packages/'+bet.package)
      .push()
      .set(bet)
      .catch((err)=>{
        // TODO: catch error
      })
};

export const updatePremiumBet = (betKey, bet) => async  dispatch => {
    premiumBetsRef
      .child('active/packages/'+bet.package+"/"+betKey)
      .set(bet)
      .catch((err)=>{
        // TODO: catch error
      })
};

export const fetchPremiumBetsStream = () => async  dispatch => {

    premiumBetsRef.child('active').on("value", snapshot => {
    
      dispatch({
        type: FETCH_PREMIUM_BETS,
        payload: snapshot.val() ? snapshot.val().packages : {}
      });
    })
}

export const fetchPremiumBetsByPackageIdStream = (packageId) => async  (dispatch) => {
    //check if package premium bets are already stored in state
    console.log("fetchPremiumBetsByPackageIdStream")
    premiumBetsRef.child('active/packages/'+packageId).on("value", snapshot => {


      dispatch({
        type: FETCH_PREMIUM_BETS,
        //add premium package bets to state
        payload: {[packageId]:snapshot.val()}
      });
    })
}

export const setPremiumBetsToEmpty = () => dispatch =>{
  dispatch({
    type: FETCH_PREMIUM_BETS,
    //add premium package bets to state
    payload: {}
  });
}


export const confirmPremiumBet = (betId, packageId, bet) => async  (dispatch, getState) => {
  /// move bet from active bets to history
  dispatch({
    type: TRANSACTION_START,
    error: null,
    status: "processing"
  });
  /// we dont neeed comment in history
  delete bet.comment

  let packageData = getState().productsData[packageId]

  let year = (new Date(bet.dateEnd*1000)). getFullYear()
  let month = (new Date(bet.dateEnd*1000)).getMonth()+1
  let week = moment().week()


  let betsAvrageDocRef = betsAvrageRef.doc(`${year-1}${year}`)
  let betsAvrageDocPrevRef  = betsAvrageRef.doc(`${year-2}${year-1}`)
  console.log(`${year-2}${year-1}`)
  if(bet.status !== "delete"){
    if(packageData.settings.subscriptionUnits){
      usersUnitsRef
        .child('packages/'+packageId)
        .once('value', (snapshot)=>{
          let usersUnits =  snapshot.val()
          let profit = bet.status === "win"? (Number(bet.input) * Number(bet.odds)-Number(bet.input)) : -Number(bet.input)
          let expiredPackageUsers = {}
          Object.entries(usersUnits.users).forEach(([userKey, userUnits])=>{
            usersUnits.users[userKey].data.unitsConsumed += profit
            if(usersUnits.users[userKey].data.unitsConsumed > usersUnits.users[userKey].data.boughtUnits){
              expiredPackageUsers = {
                ...expiredPackageUsers,
                ["users/"+userKey+"/metadata/access/packages/"+packageId]: null
              }
              delete usersUnits.users[userKey]
            }
          })
          //console.log(expiredPackageUsers,usersUnits)
          databaseRef.update({
            ...expiredPackageUsers,
            ["usersUnits/packages/"+packageId]: usersUnits
          }).catch((err)=>{
            console.log(err)
          })
        })
        .catch((err)=>{
          console.log(err)
        })
    }

    firestoreRef.runTransaction(transaction =>{
      return transaction
        .get( betsAvrageDocRef )
        .then( betsAvrageDoc =>{
          // if doc [year-1+year] do not exsist create new one nad copy year-1 from doc [year-2+year-1]
            if (!betsAvrageDoc.exists) {
              let betsAvrage = {
                [year]:{
                  packages:{
                    [packageId]:{
                      months:{
                        [month]: {
                          betsPlayed: 1,
                          betsWon: bet.status === "win"? 1:0 ,

                          inputs: Number(bet.input),
                          returns: bet.status === "win"? Number(bet.input) * Number(bet.odds) : 0 ,

                          odds: Number(bet.odds),
                          values: 1/Number(bet.oddsHouse)*100-1/Number(bet.odds)*100,

                          budget: bet.status === "win"? (Number(bet.input) * Number(bet.odds)-Number(bet.input)) : -Number(bet.input) ,
                        }
                      }
                    }
                  }
                }
              }
              
              return transaction
                .get( betsAvrageDocPrevRef )
                .then( betsAvrageDocPrev =>{
                  
                  if(betsAvrageDocPrev.exists){
                    
                    betsAvrage = {
                      ...betsAvrage, [year-1]: betsAvrageDocPrev.data()[year-1]
                    }
                    
                    // add budget from year-1 to current year
                    if(betsAvrage[year-1].packages[packageId]){
                      
                      let lastMonth = Object.keys(betsAvrage[year-1].packages[packageId].months).reduce((prev, month)=> prev = month > prev ? month : prev, 0)
                      
                      if(lastMonth)betsAvrage[year].packages[packageId].months[month].budget += betsAvrage[year-1].packages[packageId].months[lastMonth].budget
                    }

                  }
                  
                  return transaction
                     .get(betsMonthlyRef.doc(year+""+month))
                     .then((betsMonthlyDoc)=>{

                       let betsMonthlyData = betsMonthlyDoc.data()

                       if(betsMonthlyData){
                         betsMonthlyData[packageId] = {...betsMonthlyData[packageId], [betId]:bet}
                         transaction.set(betsMonthlyRef.doc(year+""+month), betsMonthlyData)
                       }else{
                         transaction.set(betsMonthlyRef.doc(year+""+month), {[packageId]: {[betId]:bet}})
                       }

                       transaction.set(betsAvrageDocPrevRef,betsAvrageDocPrev.exists ? betsAvrageDocPrev.data(): {})
                       return transaction.set(betsAvrageDocRef, betsAvrage)
                     }).catch(err =>{
                       throw err
                     })
                })

            }else {
              let betsAvrage = {...betsAvrageDoc.data()}
              let betsAvrageYear = betsAvrage[year]

              if(!betsAvrageYear.packages[packageId]){
                betsAvrageYear.packages[packageId] = {
                  months:{
                    [month]: {

                      betsPlayed: 1,
                      betsWon: bet.status === "win"? 1:0 ,

                      inputs: Number(bet.input),
                      returns: bet.status === "win"? Number(bet.input) * Number(bet.odds) : 0 ,

                      odds: Number(bet.odds),
                      values: 1/Number(bet.oddsHouse)*100-1/Number(bet.odds)*100,

                      budget: bet.status === "win"? (Number(bet.input) * Number(bet.odds)-Number(bet.input)) : -Number(bet.input) ,
                    }
                  }
                }


              }else if(!betsAvrageYear.packages[packageId].months[month]){
                betsAvrageYear.packages[packageId].months[month] = {
                  betsPlayed: 1,
                  betsWon: bet.status === "win"? 1:0 ,

                  inputs: Number(bet.input),
                  returns: bet.status === "win"? Number(bet.input)*Number(bet.odds) :0 ,

                  odds: Number(bet.odds),
                  values: 1/Number(bet.oddsHouse)*100-1/Number(bet.odds)*100,
                }


                if(!betsAvrageYear.packages[packageId].months[month-1]){

                  betsAvrageYear.packages[packageId].months[month].budget = bet.status === "win"? (Number(bet.input) * Number(bet.odds)-Number(bet.input)) : -Number(bet.input)
                  // gets budget form year-1 if it exsist, else starts counting from 0
                  if(betsAvrage[year-1].packages[packageId]){
                    let lastMonth = Object.keys(betsAvrage[year].packages[packageId].months[month]).reduce((prev, month)=> prev = month > prev ? month : prev, 0)
                    if(lastMonth)betsAvrage[year].packages[packageId].months[month].budget += betsAvrage[year-1].packages[packageId].months[lastMonth].budget
                  }
                }else{
                  betsAvrageYear.packages[packageId].months[month].budget  = betsAvrageYear.packages[packageId].months[month-1].budget + bet.status === "win"? (Number(bet.input) * Number(bet.odds)-Number(bet.input)) : -Number(bet.input)
                }
              }else{
                  betsAvrageYear.packages[packageId].months[month].betsPlayed += 1
                  betsAvrageYear.packages[packageId].months[month].betsWon += bet.status === "win"? 1:0
                  betsAvrageYear.packages[packageId].months[month].inputs += Number(bet.input)
                  betsAvrageYear.packages[packageId].months[month].returns += bet.status === "win"? Number(bet.input) * Number(bet.odds) : 0
                  betsAvrageYear.packages[packageId].months[month].odds += Number(bet.odds)
                  betsAvrageYear.packages[packageId].months[month].values += 1/Number(bet.oddsHouse)*100-1/Number(bet.odds)*100
                  betsAvrageYear.packages[packageId].months[month].budget += bet.status === "win"? (Number(bet.input) * Number(bet.odds)-Number(bet.input)) : - Number(bet.input)
              }


              return transaction
               .get(betsMonthlyRef.doc(year+""+month))
               .then((betsMonthlyDoc)=>{

                 let betsMonthlyData = {...betsMonthlyDoc.data()}

                 if(betsMonthlyData){
                   betsMonthlyData[packageId] = {...betsMonthlyData[packageId], [betId]:bet}
                   transaction.set(betsMonthlyRef.doc(year+""+month), betsMonthlyData)

                 }else{
                   transaction.set(betsMonthlyRef.doc(year+""+month), {[packageId]: {[betId]:bet}})
                 }

                 dispatch({
                   type: FETCH_STATISTIC_MONTH,
                   payload: {[year+""+month]:betsMonthlyData},
                 })

                 return transaction.set(betsAvrageDocRef, betsAvrage)
               }).catch(err =>{
                 throw err
               })
            }

        }).catch(err =>{
          throw err
        })
    })
    .then(()=>{
      // IF TRANSACTION IS SUCCESSFUL

      premiumBetsRef
        .child('active/packages/'+packageId+'/'+betId)
        .remove()
        .then(()=>{
          dispatch({
            type: TRANSACTION_END,
            message:{title:"Stava je zaključena!"},
            status: "done"
          });
        })
        .catch((err)=>{
          // TODO: catch error
          dispatch({
            type: TRANSACTION_END,
            message:{title:"Prišlo je do napake!", body: "Osveži stran in poiskusi ponovno!"},
            err: err,
            status: "error"
          });
          console.log(err)
        })
    })
    .catch(function(err) {
          // TODO: catch error
          dispatch({
            type: TRANSACTION_END,
            message:{title:"Prišlo je do napake!", body: "Osveži stran in poiskusi ponovno!"},
            err: err,
            status: "error"
          });
          console.log(err)
    });
  }else{

    /// SAVE DELETED BET
    firestoreRef.runTransaction(transaction =>{
          return transaction
             .get(betsMonthlyRef.doc(year+""+month))
             .then((betsMonthlyDoc)=>{

               let betsMonthlyData = betsMonthlyDoc.data()

               if(betsMonthlyData){
                 betsMonthlyData[packageId] = {...betsMonthlyData[packageId], [betId]: bet}
                 transaction.set(betsMonthlyRef.doc(year+""+month), betsMonthlyData)

               }else{
                 transaction.set(betsMonthlyRef.doc(year+""+month), {[packageId]: {[betId]:bet}})
               }
               return
             })
            .then(()=>{
              return premiumBetsRef
                        .child('active/packages/'+packageId+'/'+betId)
                        .remove()
                        .then(()=>{
                          return dispatch({
                            type: TRANSACTION_END,
                            message: {title:"Stava je izbrisana!"},
                            status: "done"
                          });
                        })
                        .catch((err)=>{
                          // TODO: catch error
                          throw err
                        })
            })
            .catch((err)=>{
              dispatch({
                type: TRANSACTION_END,
                message:{title:"Prišlo je do napake!", body: "Osveži stran in poiskusi ponovno!"},
                err: err,
                status: "error"
              });
            })
    })

  }



}


export const deletePremiumBet = (betId, packageId) => async  dispatch => {

    premiumBetsRef
      .child('active/packages/'+packageId+'/'+betId)
      .remove()
      .catch((err)=>{
        // TODO: catch error
        console.log(err)
      })
}

export const fetchBetsWeeklyStream = () => async  dispatch => {
    let week = moment().week()
    let year = moment().year()
    console.log("fetchBetsWeeklyStream")
    betsWeeklyRef
      .doc(year+""+week)
      .onSnapshot(doc => {

        if(!doc.data()) {
          week -= 1
          betsWeeklyRef
            .doc(year+""+week)
            .onSnapshot(doc => {
              dispatch({
                type: FETCH_BETS_HISTORY,
                payload:    doc.data().bets
              });
            }, (err) => {
              // TODO: dispatch statment for error
              console.log('Error getting document', err);
            })
        } else {
          dispatch({
            type: FETCH_BETS_HISTORY,
            payload:    doc.data().bets
          });
        }

      }, (err) => {
        // TODO: dispatch statment for error
        console.log('Error getting document', err);
      })
}


export const deletePremiumHistoryBet = (betsId) => async  dispatch => {
  var batch = firestoreRef.batch()
  betsId.forEach(betId=>{
    let betDocRef = betsRef.doc(betId)
    batch.delete(betDocRef)
  })
  // Commit the batch
  batch.commit().then(function () {
      //TODO  handle error
  });
}

export const updateBetInHistory = (betKey, bet)=> async (dispatch, getState) => {
  //console.log(betKey, bet)
  let betHistory = JSON.stringify(getState().statisticData)
  betHistory = JSON.parse(betHistory)
  let docId = ""
  let doc = {}
  let betOld = {}
  Object.entries(betHistory).forEach(([month, bets])=>{
    let betsByMonth = bets


    let betsByPackage = betsByMonth[bet.package]

    if(betsByPackage && betsByPackage[betKey]){
      docId = month
      betOld = {...betsByPackage[betKey]}
      betsByPackage[betKey] = bet
      doc = bets
      return
    }
  })

  if(docId && doc){
    let year = moment(docId, "YYYYMM").year()
    let month = moment(docId, "YYYYMM").month()+1

    betsAvrageRef
      .doc(year-1+""+year)
      .get()
      .then((doc)=>{
        let data = doc.data()
        let avrageData = data[year].packages[bet.package].months[month]

        if(betOld.status === "lose"){

          avrageData.budget += Number(betOld.input)
          avrageData.inputs -= Number(betOld.input)
          avrageData.odds -= Number(betOld.odds)

          avrageData.values -= 1/Number(betOld.oddsHouse)*100-1/Number(betOld.odds)*100

        }else if(betOld.status === "win"){

          avrageData.betsWon -= 1
          avrageData.budget -= (Number(betOld.input) * Number(betOld.odds)-Number(betOld.input))
          avrageData.inputs -= Number(betOld.input)
          avrageData.odds -= Number(betOld.odds)
          avrageData.returns -= Number(betOld.input) * Number(betOld.odds)
          avrageData.values -= 1/Number(betOld.oddsHouse)*100-1/Number(betOld.odds)*100

        }else if(bet.status !== "delete"){
          avrageData.betsPlayed = 1
        }

        if(bet.status !== "delete"){
          //console.log(JSON.stringify(avrageData))
          avrageData.betsWon += bet.status === "win"? 1:0
          avrageData.inputs += Number(bet.input)
          avrageData.returns += bet.status === "win"? Number(bet.input) * Number(bet.odds) : 0
          avrageData.odds += Number(bet.odds)
          avrageData.values += 1/Number(bet.oddsHouse)*100-1/Number(bet.odds)*100
          avrageData.budget += bet.status === "win"? (Number(bet.input) * Number(bet.odds)-Number(bet.input)) : -Number(bet.input)
        }else{
          avrageData.betsPlayed -= 1
        }


        //console.log(avrageData)
        betsAvrageRef.doc(year-1+""+year).set(data)
      })

    betsMonthlyRef
      .doc(docId)
      .set(doc)
      .then(()=>{
        dispatch({
          type: FETCH_STATISTIC_MONTH,
          payload: {[docId]:doc}
        });
        dispatch({
          type: TRANSACTION_END,
          message: {title:"Stava je bila posodbljena!", body:"", type:"info"},
          status: "done"
        });
      })
      .catch(()=>{
        dispatch({
          type: TRANSACTION_END,
          message: {title:"Prišlo je do napake!", body:"Poiskusi ponovno!", type:"error"},
          status: "error"
        });
      })
  }else{
    dispatch({
      type: TRANSACTION_END,
      message: {title:"Prišlo je do napake!", body:"Poiskusi ponovno!", type:"error"},
      status: "error"
    });
  }

}

/// STATISTIC DATA

export const fetchPackageStatisticOnce = () => async dispatch => {
  console.log("fetchPackageStatisticOnce")
  let year = moment().year()
  betsAvrageRef
    .doc(`${year-1}${year}`)
    .get()
    .then(doc => {
      let statistic = {packages:{}}
      if(!doc.data()) return
      Object.keys(doc.data()).forEach((yearKey)=>{
        let statistic__year = doc.data()[yearKey]

        Object.keys(statistic__year.packages).forEach(packageKey =>{
          let statistic__year__package = statistic__year.packages[packageKey]

          Object.keys(statistic__year__package.months).forEach(monthKey=>{
            let statistic__year__package__month = statistic__year__package.months[monthKey]
            /// add 0 to month number if it is only 1 digit, we need double digit number becouse of sorting exp. (201808 not 20188 , cuz 201712 > 20188 err!)
            monthKey = monthKey.toString().length === 1 ? "0"+monthKey : monthKey
            if(statistic.packages[packageKey]){
              statistic.packages[packageKey].months = {...statistic.packages[packageKey].months, [Number(yearKey+""+monthKey)]: statistic__year__package__month}
            }else{
              statistic.packages[packageKey] = {
                months:{
                  [Number(yearKey+""+monthKey)]: statistic__year__package__month
                }
              }
            }
          })
        })
      })

      dispatch({
        type: FETCH_PACKAGE_STATISTIC,
        payload: statistic
      });
    })
}

export const fetchStatisticByConditionsOnce = (dateFrom, dateTo) => async (dispatch, getState) => {
  console.log("fetchStatisticByConditionsOnce")
  dateFrom = moment.unix(dateFrom)
  dateTo = moment.unix(dateTo)

  if(dateTo < dateFrom) return

  let monthFrom = dateFrom.month()+1
  let monthTo = dateTo.month()+1
  let queries = []
  let queriedMonths = []
  let statisticDataState = getState().statisticData
  let startDate = dateFrom

  while(startDate.isSameOrBefore(dateTo)){

    if(!statisticDataState[startDate.year()+""+(startDate.month()+1)]){
      queriedMonths.push(startDate.year()+""+(startDate.month()+1))
      queries.push(betsMonthlyRef.doc(startDate.year()+""+(startDate.month()+1)).get())
      //console.log(startDate.year()+""+(startDate.month()+1))
    }
    startDate.add(1, "months")
  }


  if(queries.length !== 0){

    Promise.all(queries).then((docs)=>{
      let bets = {}

      docs.forEach((doc, i)=>{
          let data = doc.data()
          bets = {...bets, [queriedMonths[i]]: data ? data : {}}

      })


      dispatch({
        type: FETCH_STATISTIC,
        payload: bets
      });

    }).catch((err)=>{
      console.log(err)
    })
  }


  /*
  betsWeeklyRef
    .get()
    .then(snapshot => {
      let docs = []
      snapshot.forEach((doc)=>{
        docs.push(doc.data())
      })

      dispatch({
        type: FETCH_STATISTIC,
        payload: docs
      });
    })
    */
}

////// FREE BET PAGE SETTINGS
export const fetchFreeBetPageOnce = ()=> async dispatch =>{
  console.log("fetchFreeBetPageOnce")
  freeBetPageRef.once("value", snapshot => {
    dispatch({
      type: FETCH_FREE_BET_PAGE,
      payload: snapshot.val()
    });
  })
  .catch(err=>console.log(err))
}

export const updateFreeBetPage = (obj)=> async dispatch =>{
  freeBetPageRef
    .set(obj)
    .catch((err)=>{
      // TODO: catch error
    })
}

/// BET VIDEOS
export const fetchBetVideosStream = ()=> async dispatch =>{
  console.log("fetchBetVideosStream")
  betVideosRef.orderByChild('date').on("value", snapshot => {
    let betsVideos = {}
    snapshot.forEach((child)=>{

      betsVideos = {...betsVideos, [child.key]:child.val()}
    })
    dispatch({
      type: FETCH_BET_VIDEOS,
      payload: betsVideos
    });
  })
}

export const fetchBetVideosOnce = ()=> async dispatch =>{
  console.log("fetchBetVideosOnce")
  betVideosRef.orderByChild('date').once("value", snapshot => {
    let betsVideos = {}
    snapshot.forEach((child)=>{

      betsVideos = {...betsVideos,[child.key]: child.val()}
    })
    dispatch({
      type: FETCH_BET_VIDEOS,
      payload: betsVideos
    });
  })
  .catch(err=>console.log(err))
}

export const addBetVideo = (obj)=> async dispatch =>{
  betVideosRef
    .push()
    .set(obj)
    .catch((err)=>{
      // TODO: catch error
    })
}

export const deleteBetVideo = (id)=> async dispatch =>{
  betVideosRef
    .child(id)
    .remove()
    .catch((err)=>{
      // TODO: catch error
    })
}

///// PACKAGE ORDERS
export const fetchActiveOrdersStream = () => async dispatch =>{
  ordersRef
    .child('active')
    .on("value", snapshot => {
      dispatch({
        type: FETCH_ALL_ORDERS,
        payload: snapshot.val()
      });
  })
}

export const fetchAllUserOrdersOnce = (uid) => async (dispatch, getState) =>{
  console.log("fetchAllUserOrdersOnce")
  // before fetching fdata from database check if data already exsist in state
  let ordersData = getState().ordersData

  if(!ordersData[uid]){

    ordersRef
      .child('active/users/'+uid)
      .once("value", snapshotActive => {
        let orders = snapshotActive.val()

        ordersRef.child('history/users/'+uid)
        .once("value", snapshotHistory => {
          orders = {...orders, ...snapshotHistory.val()}

          dispatch({
            type: FETCH_USER_ORDERS,
            payload: {[uid]:orders}
          });
        })
        .catch(err=>{throw err})
    })
    .catch(err=>console.log(err))
  }
}

export const fetchUserOrdersHistoryOnce = (uid) => async (dispatch, getState) =>{
  console.log("fetchUserOrdersHistoryOnce")
  // before fetching fdata from database check if data already exsist in state
  let ordersHistoryData = getState().ordersHistoryData

  if(!ordersHistoryData[uid]){


      ordersRef.child('history/users/'+uid)
      .once("value", snapshotHistory => {

        dispatch({
          type: FETCH_USER_HISTORY_ORDERS,
          payload: snapshotHistory.val(),
          uid
        });
      })
      .catch(err=>{throw err})

  }
}

export const fetchAllOrderHistroyDataOnce = (uid) => async (dispatch, getState) =>{
  console.log("fetchAllOrderHistroyDataOnce")



      ordersRef.child('history')
      .once("value", snapshotHistory => {

        dispatch({
          type: FETCH_ALL_HISTORY_ORDERS,
          payload: snapshotHistory.val(),

        });
      })
      .catch(err=>{throw err})


}



export const addNewActiveOrder = (order, uid, packageName, userEmail)=> async dispatch =>{

  if(order.paymentType === "trr"){
    dispatch({
      type: TRANSACTION_START,
      error: null,
      status: "processing"
    });

    let newOrderRef = ordersRef.child('active/users/'+uid).push()
    newOrderRef
      .set(order)
      .then(()=>{

          ordersRef.child('active/users/'+uid).on('child_changed', (snapshot)=>{

            if(snapshot.key === newOrderRef.key){
              ReactPixel.trackCustom( "PurchaseUncomplited", {
                value: order.value,
                userMail: order.userMail,
                packageId: order.package

              })

              dispatch({
                type: ORDER_COMMITED,
                payload: snapshot.val()
              })

              dispatch({
                type: TRANSACTION_END,
                message:{title:"Naročilo je bilo uspešno oddano!"},
                status: "done"
              });
            }
          })
    })
    .catch((err)=>{
      console.log(err)
      dispatch({
        type: TRANSACTION_END,
        message:{title:"Prišlo je do napake!", body:"Osveži stran in poiskusi ponovno!"},
        status: "error"
      });
    })
  }else if(order.paymentType === "paypal"){
    dispatch({
      type: TRANSACTION_START,
      error: null,
      status: "processing"
    });

    let newOrderRef = ordersRef.child('active/users/'+uid).push()
    newOrderRef
      .set(order)
      .then(()=>{
           let data = {
             packageName: packageName,
             duration: order.duration,
             price: order.amount,

             oid: newOrderRef.key,
             uid: uid,
             pid: order.package
           }
           //https://betmoneymaker-3c70b.firebaseapp.com/pay
       
           const fetchMatchOdds = cloudFunction.httpsCallable('pay')
           console.log("hi")
           fetchMatchOdds(data).then((result)=>{
              let resData = result.data
              console.log(result)
              if(resData.approval_url)window.location.replace(resData.approval_url);
              
           }).catch(error => console.error('Error:', error));

           /*
           fetch("/pay", {
             method: 'POST', // or 'PUT'
             body: JSON.stringify(data), // data can be `string` or {object}!

           })
           .then(res => {

             return res.json()

           })
           .then(data=>{
             //console.log(data.approval_url)
             if(data.approval_url)window.location.replace(data.approval_url);
           })
           .catch(error => console.error('Error:', error));
           */
      })
      .catch((err)=>{
        console.log(err)
        dispatch({
          type: TRANSACTION_END,
          message:{title:"Prišlo je do napake!", body:"Osveži stran in poiskusi ponovno!"},
          status: "error"
        });
      })

  }else if(order.paymentType === "moneta"){

    let newOrderRef = ordersRef.child('active/users/'+uid).push()
    newOrderRef
      .set(order)
      .then(()=>{
           let data = {
             packageName: packageName,
             duration: order.duration,
             phoneNumber: order.phoneNumber,
             price: order.amount,
             oid: newOrderRef.key,
             uid: uid,
             userEmail,
             pid: order.package
           }

           //console.log(data)
           fetch("/moneta/pay", {
             method: 'POST', // or 'PUT'
             body: JSON.stringify(data), // data can be `string` or {object}!

           })
           .then(res => {
             console.log("listening to orders/active/users/"+uid)
             ordersRef.child('active/users/'+uid).on('child_changed', (snapshot)=>{

               if(snapshot.key === newOrderRef.key){

                let order = snapshot.val()
                 if(order.paied){
                   dispatch({
                     type: MONETA_TRANSACTION_STATUS,
                     status: "success",
                   });
                 }
               }
             })
           })
           .catch(err => {
             console.log(err)
             dispatch({
               type: MONETA_TRANSACTION_STATUS,
               status: "error"
             });
           });
      })
      .catch((err)=>{
        console.log(err)
        dispatch({
          type: MONETA_TRANSACTION_STATUS,
          status: "error"
        });
      })
  }
  /*

  let newOrderRef = ordersRef.child('active/users/'+uid).push()
  newOrderRef
    .set(order)
    .then(()=>{
      if(order.paymentType === "trr"){

        ordersRef.child('active/users/'+uid).on('child_changed', (snapshot)=>{

          if(snapshot.key === newOrderRef.key){
            dispatch({
              type: ORDER_COMMITED,
              payload: snapshot.val()
            })
            dispatch({
              type: TRANSACTION_END,
              message:{title:"Naročilo je bilo uspešno oddano!"},
              status: "done"
            });
          }
        })
      }else if(order.paymentType === "paypal"){

         let data = {
           packageName: packageName,
           duration: order.duration,
           price: order.amount,

           oid: newOrderRef.key,
           uid: uid,
           pid: order.package
         }
         //https://betmoneymaker-3c70b.firebaseapp.com/pay
         console.log(data)
         fetch("/pay", {
           method: 'POST', // or 'PUT'
           body: JSON.stringify(data), // data can be `string` or {object}!

         })
         .then(res => {

           return res.json()

         })
         .then(data=>{
           //console.log(data.approval_url)
           if(data.approval_url)window.location.replace(data.approval_url);
         })
         .catch(error => console.error('Error:', error));
      }else if(order.paymentType === "moneta"){

         let data = {
           packageName: packageName,
           duration: order.duration,
           phoneNumber: order.phoneNumber,
           price: order.amount,
           oid: newOrderRef.key,
           uid: uid,
           userEmail,
           pid: order.package
         }

         console.log(data)
         fetch("/moneta/pay", {
           method: 'POST', // or 'PUT'
           body: JSON.stringify(data), // data can be `string` or {object}!

         })
         .then(res => {

           return res.json()

         })
         .then(data=>{
           //console.log(data.approval_url)
           ordersRef.child('orders/active/users/'+uid).on('child_changed', (snapshot)=>{
             if(snapshot.key === newOrderRef.key){
               dispatch({
                 type: ORDER_COMMITED,
                 payload: snapshot.val()
               })
               dispatch({
                 type: TRANSACTION_END,
                 message:{title:"Naročilo je bilo uspešno oddano!"},
                 status: "done"
               });
             }
           })
         })
         .catch(error => console.error('Error:', error));
      }
    })
    .catch((err)=>{
      console.log(err)
      dispatch({
        type: TRANSACTION_END,
        message:{title:"Prišlo je do napake!", body:"Osveži stran in poiskusi ponovno!"},
        status: "error"
      });
    })
    */
}

export const deleteActiveOrder = (uid, orderKey) => async dispatch =>{

  ordersRef
    .child("active/users/"+uid+"/"+orderKey)
    .remove()
    .then(()=>{

    })
    .catch((err)=>{
      // TODO: catch error
      console.log(err)
    })
}

function getNumOfDays(numOfMonths){
  let days = 0
  let currenDate = moment()
  for(let i=0; i < numOfMonths; i++){

    days+= currenDate.daysInMonth()
    currenDate.add(1, 'months')
  }

  return days
}

export const confirmActiveOrder = (uid, orderKey, order, packageName, invoiceListed) => async (dispatch, getState) =>{

  let user = await usersRef.child(uid).once("value")
  user = user.val()

  let invoice = {
    "customerEmail": order.userMail,
    "customerName": user.firstName +" "+ user.lastName,
    "customerAddress":user.address,
    "customerCity":user.city,
    "customerPostalCode": user.postalNumber,
    "invoiceDate": moment().format("DD.MM.YYYY"),
    "invoiceServiceDate": moment().format("DD.MM.YYYY")+ " - " + moment().add(order.duration, "months").format("DD.MM.YYYY"),
    "packageName": packageName,
    "orderDuration": order.duration,
    "orderAmount": order.amount +"€",
    "listed": invoiceListed,
  }


  if(order.activated){
    databaseRef
      .update({
        ["orders/active/users/"+uid+"/"+orderKey]: null,
        ["orders/history/users/"+uid+"/"+orderKey]: order,
        ["invoices/"+orderKey]: invoice
      })
      .then(()=>{

        dispatch({
          type:TRANSACTION_END,
          message: {title:"Naročilo je bilo potrjenot!", body: invoiceListed ? "Račun je bil poslan na uporabnikov naslov!": "", type:"info"}
        })
      })
      .catch((err)=>{
        dispatch({
          type:TRANSACTION_END,
          message: {title:"Prišlo je do napake!", body: "Osveži stran in posikusi ponovno!", type:"error"}
        })
      })
  }else{

    order.activated = moment().unix()

    let year = moment().year()
    let month = moment().month()
    let packageId = order.package
    let packageData = getState().productsData[packageId]

    let numOfDays = Math.ceil(getNumOfDays(order.duration))
    let expiresOnDate = moment().add(numOfDays, 'days').unix()
    let timestamp = serverTimestamp
    let duration = numOfDays*86400000*packageData.settings.subscriptionSpan


    if(packageData.settings.subscriptionUnits){
      let subscriptionUnitsAmount =  packageData.settings.subscriptionUnitsAmount * order.duration
      databaseRef
        .update({
          ["invoices/"+orderKey]: invoice,
          ["orders/active/users/"+uid+"/"+orderKey]: null,
          ["orders/history/users/"+uid+"/"+orderKey]: order,
          ["users/"+uid+"/metadata/access/packages/"+order.package]: {
            duration,
            expiresAt: expiresOnDate,
            timestamp
          },
          ["usersUnits/packages/"+packageId+"/users/"+uid+"/data"]:{
            unitsConsumed: 0,
            boughtUnits: subscriptionUnitsAmount,
          },
          ["activeSubs/packages/"+order.package+"/"+uid]:{
            duration,
            expiresAt: expiresOnDate,
            timestamp,
            email: user.email ? user.email : ""
          }
        })
        .then(()=>{
          ReactPixel.trackCustom( "PurchaseSuccess", {value: order.amount, packageId: order.package, userMail: order.userMail} )
          dispatch({
            type:TRANSACTION_END,
            message: {title:"Naročilo je bilo potrjenot!", body: invoiceListed ? "Račun je bil poslan na uporabnikov naslov!": "", type:"info"}
          })
        })
        .catch((err)=>{
          dispatch({
            type:TRANSACTION_END,
            message: {title:"Prišlo je do napake!", body: "Osveži stran in posikusi ponovno!", type:"error"}
          })
        })
    }else{
      databaseRef
        .update({
          ["invoices/"+orderKey]: invoice,
          ["orders/active/users/"+uid+"/"+orderKey]: null,
          ["orders/history/users/"+uid+"/"+orderKey]: order,
          ["users/"+uid+"/metadata/access/packages/"+order.package]: {
            duration,
            expiresAt: expiresOnDate,
            timestamp
          },
          ["activeSubs/packages/"+order.package+"/"+uid]:{
            duration,
            expiresAt: expiresOnDate,
            timestamp,
            email: user.email ? user.email : ""
          }
        })
        .then(()=>{
          ReactPixel.trackCustom( "PurchaseSuccess", {value: order.amount, packageId: order.package, userMail: order.userMail} )
          dispatch({
            type:TRANSACTION_END,
            message: {title:"Naročilo je bilo potrjenot!", body: invoiceListed ? "Račun je bil poslan na uporabnikov naslov!": "", type:"info"}
          })
        })
        .catch((err)=>{
          dispatch({
            type:TRANSACTION_END,
            message: {title:"Prišlo je do napake!", body: "Osveži stran in posikusi ponovno!", type:"error"}
          })
        })
    }

  }

}


///// FIREBASE MESSAGING SERVICE
export const fcmRequestPermission = ()=> async dispatch =>{
  if(!firebaseMessaging){
    dispatch({
      type: DEVICE_FCM_TOKEN_SUPORTED,
      payload: false,
    })
    return
  }
  firebaseMessaging
     .requestPermission()
     .then(() => {

        return firebaseMessaging.getToken();
      })
     .then(token => {

         dispatch({
           type: SET_DEVICE_FCM_TOKEN,
           payload: token,
         })
        //you probably want to send your new found FCM token to the
        //application server so that they can send any push
        //notification to you.
      })
     .catch(error => {
        if (error.code === "messaging/permission-blocked") {
           console.log("Please Unblock Notification Request Manually");
        } else {
           console.log("Error Occurred", error);
        }
       });
}

export const invokeFcmMessageListener = ()=> async dispatch =>{
  if(!firebaseMessaging)return
  firebaseMessaging
     .requestPermission()
     .then(() => {
       firebaseMessaging.onMessage(payload => {

         //console.log(payload)
          dispatch({
            type: DISPLAY_INFO_DATA,
            payload: payload.notification,
          })
       });
      })
     .catch(error => {
        if (error.code === "messaging/permission-blocked") {
           console.log("Please Unblock Notification Request Manually");
        } else {
           console.log("Error Occurred", error);
        }
       });

}


export const fetchFcmSubscriptionsOnce = (uid, packages) => async dispatch => {
  console.log("fetchFcmSubscriptionsOnce")
  let queries = []

  packages.forEach((packageId)=>{
    queries.push(fcmSubscriptionsRef.child('data/packages/'+packageId+"/"+uid).once("value", (snapshot)=>snapshot))
  })

  Promise.all(queries).then(results =>{
    let data = {}
    results.forEach((dataSnaps,i)=>{
      data = {...data, [packages[i]]:dataSnaps.val()}
    })

    dispatch({
      type: FETCH_FCM_USER_SUBSCRIPTIONS,
      payload: data
    })
  })
  .catch(err=>console.log(err))


}

export const registerNewFcmSubscription = (packageId, uid, data) => async (dispatch) =>{
  fcmSubscriptionsRef
    .child('data/packages/'+packageId+"/"+uid)
    .set(data)
    .then(()=>{

      dispatch({
        type: UPDATE_FCM_USER_SUBSCRIPTIONS,
        packageId,
        uid,
        payload: data

      })
    })
    .catch((err)=>{
      console.log(err)
    })
}


//// WEBPAGE INFO SNACKBAR
export const closeWebpageDisplayedInfo= () => dispatch => {
  dispatch({
    type: DISPLAY_INFO_DATA,
    payload: null
  });
};

export const showWebpageDisplayedInfo = (title, body, type, link) => dispatch => {
  dispatch({
    type: DISPLAY_INFO_DATA,
    payload: {title, body, type, link}
  });
};

///// AUTH ACTIONS
export const loginDialogState = (active) => dispatch => {
  dispatch({
    type: SHOW_LOGIN_DIALOG,
    isActive: active
  });
};

export const createNewUser = (email, password) => dispatch => {
  dispatch({
    type: TRANSACTION_START,
    error: null,
    status: "processing"
  })
  authRef
    .createUserWithEmailAndPassword(email, password)
    .then(result => {

      dispatch({
        type: TRANSACTION_END,
        message: {title:"Registracija je bila uspešna", body:"Na naslov" +email+" je bilo poslano sporočilo za potrditev!", type: "info"},
        status: "done"
      });
    })
    .catch(function(error) {
      // Handle Errors here.

    });
};

export const changeUserPassword = (password) => dispatch =>{
  dispatch({
    type: TRANSACTION_START,
    error: null,
    status: "processing"
  })
  authRef.currentUser.updatePassword(password).then(function() {
    dispatch({
      type: TRANSACTION_END,
      message: {title: "Geslo je bilo uspešno spremenjeno!",body:null, type: "info"},
      status: "done"
    })
  }).catch(function(error) {
    console.log(error)
    dispatch({
      type: TRANSACTION_END,
      message: {title: "Prišlo je do napake!", body:"Odjavi se iz računa in poiskusi ponovno!" ,type: "error"},
      status: "done"
    })
  });
}

export const changeUserEmail = (email) => dispatch =>{
  dispatch({
    type: TRANSACTION_START,
    error: null,
    status: "processing"
  })
  authRef.currentUser.updateEmail(email).then(function() {
    dispatch({
      type: TRANSACTION_END,
      message: {title: "E-naslov je bil uspešno spremenjen!",body:null, type: "info"},
      status: "done"
    })
  }).catch(function(error) {
    console.log(error)
    dispatch({
      type: TRANSACTION_END,
      message: {title: "Prišlo je do napake!", body:"Odjavi se iz računa in poiskusi ponovno!" ,type: "error"},
      status: "done"
    })
  });
}

export const passwordResetRequest = (emailAddress) => dispatch => {
  authRef.sendPasswordResetEmail(emailAddress).then(function() {
    dispatch({
      type: DISPLAY_INFO_DATA,
      payload: {body: null, title:"Navodila za zamenjavo gesla, so bila poslana na " + emailAddress, type: "info"}
    })
  }).catch(function(error) {
    // An error happened.
  });
}

export const signIn = (email, password) => dispatch => {
  dispatch({
    type: TRANSACTION_START,
    error: null,
    status: "processing"
  });
  authRef
    .signInWithEmailAndPassword(email, password)
    .then(result => {
      dispatch({
        type: TRANSACTION_END,
        message: {title:"Prijava je bila uspešna!", body:null, type: "info"},
        status: "done"
      });

    })
    .catch((error) => {
      // Handle Errors here.


      if(error.code === "auth/wrong-password" || error.code ===  "auth/invalid-email" || error.code === "auth/user-not-found"){
        console.log(error)
        dispatch({
          type: TRANSACTION_END,
          message: {title:"Geslo ali e-poštni naslov je napačno!", body:"", type: "error"},
          status: "error"
        });
      }else{
        dispatch({
          type: TRANSACTION_END,
          message: {title:"Neznana napaka!", body:"Osveži stran in poiskusi ponovno!", type: "error"},
          status: "error"
        });
      }



    });
};

export const signInWithProvider = (providerName) => dispatch => {

  if(providerName === "facebook"){
    authRef
    .signInWithRedirect(providerFacebook)
    .then(function(result) {
      // This gives you a Facebook Access Token. You can use it to access the Facebook API.
      var token = result.credential.accessToken;
      // The signed-in user info.
      var user = result.user;

    })
    .catch(function(error) {
      // Handle Errors here.
      var errorCode = error.code;
      var errorMessage = error.message;
      // The email of the user's account used.
      var email = error.email;
      // The firebase.auth.AuthCredential type that was used.
      var credential = error.credential;
      // ...

      console.log(error)
      if(errorCode === "auth/account-exists-with-different-credential"){
        dispatch({
          type: DISPLAY_INFO_DATA,
          payload: {title: "Uporabnik "+email+" je že registreran!", body:"Poiskusi se prijaviti z e-poštnim naslovom ali Google računom",type: "info"}
        });
      }

    });
  }else if(providerName === "google"){
    authRef.signInWithRedirect(provider)

  }

};

export const getAuthRedirectResponse = ()=> dispatch =>{
  authRef
    .getRedirectResult()
    .then(function(result) {
      if (result.user) {
        dispatch({
          type: DISPLAY_INFO_DATA,
          payload: {title:"Prijava je bila uspešna!", body:null, type: "info"}
        })
      }

    })
    .catch(function(error) {
      // Handle Errors here.
      let errorCode = error.code;
      let email = error.email;
      if(errorCode === "auth/account-exists-with-different-credential"){
        dispatch({
          type: DISPLAY_INFO_DATA,
          payload: {title: "Uporabnik "+email+" je že registreran!", body:"Poiskusi se prijaviti z e-poštnim naslovom ali Google računom",type: "error"}
        });
      }else{
        dispatch({
          type: DISPLAY_INFO_DATA,
          payload: {title: "Prišlo je do napake!", body:"Osveži stran in poiskusi ponovno!",type: "error"}
        });
      }

    });
}


export const signOut = () => dispatch => {
  authRef
    .signOut()
    .then(() => {
      // Sign-out successful.
    })
    .catch(error => {
      console.log(error);
    });
};



// WEBPACK FOOTER //
// ./src/actions/index.js